export default __webpack_public_path__ + "static/media/add-schedule-enabled.f431dd3f.svg";